export const API_SUCCESS_MESSAGE = "保存しました。";
export const API_UNKNOWN_ERROR_MESSAGE = "不明なエラー";
export const DEFAULT_TIMER = 1000;
export const MAX_INTEGER = 2147483646;
export const PASSWORD_CHANGE_SUCCESS_MESSAGE = "パスワードが再設定されました。";
export const RESEND_COOLDOWN_SECONDS = 60;
export const RESEND_VERIFY_CODE_COOLDOWN_STORAGE_KEY = "resend-verify-code-cooldown-until";
export const RESEND_RECOVER_EMAIL_COOLDOWN_STORAGE_KEY = "resend-recover-email-cooldown-until";
export const RESEND_IMPERSONATION_VERIFY_CODE_COOLDOWN_STORAGE_KEY = "resend-impersonation-verify-code-cooldown-until";
